import { type TDispatchStructuredLogUserEngagement } from '../types/adscopilot-structured-log-types';
import { createStructureLogUserEngagement } from './create-structured-log-user-engagement';
import { dispatchStructuredLogEvent } from './dispatch-structured-log-event';

export const dispatchStructuredLogUserEngagementEvent: TDispatchStructuredLogUserEngagement = (params) => {
  const { activity } = params;

  if (
    (activity as any).type !== 'messageReaction'
    || (activity as any)?.isFromRestore === true
  ) return;

  const structuredLogMessage = createStructureLogUserEngagement(params);

  dispatchStructuredLogEvent(structuredLogMessage);
};
